<template>
  <div class="flex flex-col flex-1 pt-8">
    <breadcrumbs-trustpilot-bar
      :v-if="showBreadcrumbs"
      :custom-crumbs="customCrumbs"
      color="gray-black"
      :add-json-ld="true"
    />
    <banner-image
      :src="{ mobile: imageMobile, desktop: image }"
      :with-breadcrumbs="showBreadcrumbs"
      :class="[`${bannerExtraClasses} bg-primary`]"
      full
    />
    <div class="bg-white py-4 relative mb-8">
      <container>
        <row>
          <column class="w-full">
            <main-title>{{ title }}</main-title>
          </column>
        </row>
        <row v-if="isUspsVisible">
          <div
            class="w-full flex flex-col grow flex-wrap justify-end mt-2 md:mt-0"
          >
            <row>
              <column class="w-full mt-2">
                <div
                  class="flex flex-col lg:flex-row relative px-4 py-4 lg:px-2 lg:py-2 bg-gray-light border border-gray lg:border-0 lg:bg-transparent rounded"
                >
                  <usps
                    v-for="({ transKey, type }, key) in uspsConfig"
                    :key="key"
                    :plain-text="$t(`organisms.brand_banner.usps.${transKey}`)"
                    injected
                    :icon-type="type"
                    class="lg:py-0 lg:ps-8 py-1 first:ps-0 text-primary lg:text-base"
                  />
                  <a
                    class="absolute lg:hidden flex items-center justify-center top-0 end-0 w-8 h-8 rounded-full bg-white border border-gray translate-center-up"
                    href="#"
                    @click.prevent="handleClose"
                  >
                    <icon icon="close" color="black" />
                  </a>
                </div>
              </column>
            </row>
          </div>
        </row>
      </container>
    </div>
  </div>
</template>

<script>
import VueTypes from 'vue-types'
import { Usps, Icon } from '~/components/atoms'
import { BannerImage, MainTitle } from '~/components/molecules'
import { Container, Row, Column } from '~/components/grid'
import { BreadcrumbsTrustpilotBar } from '~/components/organisms'
import { uspsConfig } from '~/enums/usps-config'

export default {
  components: {
    BannerImage,
    MainTitle,
    Container,
    Row,
    Column,
    BreadcrumbsTrustpilotBar,
    Usps,
    Icon,
  },
  props: {
    image: VueTypes.object.def({}),
    imageMobile: VueTypes.object.def({}),
    title: VueTypes.string.def(''),
    showBreadcrumbs: VueTypes.boolean,
    bannerExtraClasses: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      uspsConfig,
      isUspsVisible: true,
    }
  },
  computed: {
    customCrumbs() {
      return [
        {
          label: this.title,
          title: this.title,
        },
      ]
    },
  },
  methods: {
    handleClose() {
      this.isUspsVisible = false
    },
  },
}
</script>
